"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var AXSBlock_1 = __importDefault(require("../AXSBlock/AXSBlock"));
var styled_components_1 = __importDefault(require("styled-components"));
var colors_1 = require("../../constants/colors");
var AXSIcon_1 = __importDefault(require("../../elements/AXSIcon"));
var classnames_1 = __importDefault(require("classnames"));
var utils_1 = require("../../utils");
var react_outside_click_handler_1 = __importDefault(require("react-outside-click-handler"));
var ModalWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  height: calc(100vh);\n  left: 0;\n  position: fixed;\n  top: 0;\n  width: calc(100vw);\n  z-index: ", ";\n"], ["\n  background-color: ", ";\n  height: calc(100vh);\n  left: 0;\n  position: fixed;\n  top: 0;\n  width: calc(100vw);\n  z-index: ", ";\n"])), function (_a) {
    var overlayColor = _a.overlayColor, theme = _a.theme;
    return utils_1.parseThemePath(overlayColor, theme, colors_1.colors.BLACK_70);
}, function (_a) {
    var zIndex = _a.zIndex;
    return zIndex;
});
var ModalWindow = styled_components_1.default(AXSBlock_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: ", ";\n  left: ", ";\n  padding: 16px;\n  position: fixed;\n  top: ", ";\n  width: ", ";\n"], ["\n  height: ", ";\n  left: ", ";\n  padding: 16px;\n  position: fixed;\n  top: ", ";\n  width: ", ";\n"])), function (_a) {
    var height = _a.height;
    return height ? height : 'calc(100vh - 100px)';
}, function (_a) {
    var width = _a.width;
    return width ? "calc((100vw - " + width + ") / 2)" : '100px';
}, function (_a) {
    var height = _a.height;
    return height || height !== 'auto' ? "calc((100vh - " + height + ") / 2)" : '50px';
}, function (_a) {
    var width = _a.width;
    return width ? width : 'calc(100vw - 200px)';
});
var Close = styled_components_1.default(AXSIcon_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  cursor: pointer;\n  position: absolute;\n  right: 40px;\n  top: 10px;\n"], ["\n  cursor: pointer;\n  position: absolute;\n  right: 40px;\n  top: 10px;\n"])));
var Title = styled_components_1.default.h2(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 36px;\n  font-weight: normal;\n  margin-bottom: 48px;\n  margin-top: 55px;\n  text-align: center;\n"], ["\n  color: ", ";\n  font-size: 36px;\n  font-weight: normal;\n  margin-bottom: 48px;\n  margin-top: 55px;\n  text-align: center;\n"])), function (_a) {
    var titleColor = _a.titleColor, theme = _a.theme;
    return utils_1.parseThemePath(titleColor, theme, colors_1.colors.BLUE_300);
});
var AXSModal = function (_a) {
    var _b;
    var active = _a.active, _c = _a.enableOutsideClick, enableOutsideClick = _c === void 0 ? true : _c, children = _a.children, _d = _a.backgroundColor, backgroundColor = _d === void 0 ? 'axsui.components.modal.backgroundColor' : _d, _e = _a.color, color = _e === void 0 ? 'axsui.components.modal.color' : _e, handleClose = _a.handleClose, height = _a.height, _f = _a.iconColor, iconColor = _f === void 0 ? 'axsui.components.modal.closeIconColor' : _f, _g = _a.overlayColor, overlayColor = _g === void 0 ? 'axsui.components.modal.overlayBackgroundColor' : _g, showClose = _a.showClose, theme = _a.theme, title = _a.title, _h = _a.titleColor, titleColor = _h === void 0 ? 'axsui.components.modal.titleColor' : _h, width = _a.width, _j = _a.zIndex, zIndex = _j === void 0 ? 1000 : _j, props = __rest(_a, ["active", "enableOutsideClick", "children", "backgroundColor", "color", "handleClose", "height", "iconColor", "overlayColor", "showClose", "theme", "title", "titleColor", "width", "zIndex"]);
    var outsideClickHandler = enableOutsideClick && handleClose ? function () { return handleClose(); } : function () { return null; };
    return (active && (React.createElement(ModalWrapper, { overlayColor: overlayColor, zIndex: zIndex },
        React.createElement(react_outside_click_handler_1.default, { onOutsideClick: outsideClickHandler },
            React.createElement(ModalWindow, __assign({ active: active, backgroundColor: backgroundColor, height: height, width: width }, props, { color: color, className: classnames_1.default(['c-axs-modal', (_b = {}, _b['is-active'] = active, _b), props.className]) }),
                showClose &&
                    React.createElement(Close, { className: "c-axs-modal__close", onClick: handleClose, color: iconColor, name: "close" }),
                title && React.createElement(Title, { className: "c-axs-modal__title", titleColor: titleColor }, title),
                children)))));
};
exports.default = AXSModal;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map